import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { logout } from '../../App';
import Cookies from 'js-cookie';
import axiosInstance from '../../api/axiosInstance';
import {
    HiOutlineHome,
    HiOutlineCalendar,
    HiOutlineUserGroup,
    HiOutlineClock,
    HiOutlineCash,
    HiOutlineBell,
    HiOutlineLogout,
    HiOutlineMenuAlt2,
    HiOutlineX,
    HiOutlineUserCircle,
    HiOutlineClipboardList,
    HiOutlineStar,
    HiOutlineChevronDown,
    // HiOutlineSpeakerphone,
    // HiOutlineSupport,
    // HiOutlineShare
} from 'react-icons/hi';
// import { HiOutlineWallet } from 'react-icons/hi2';
import AvelatorLogo from '../../assets/Doctor_Images/Avelator_Logo.png';

const menuItems = [
    { name: 'Dashboard', icon: HiOutlineHome, path: '/dashboard' },
    { name: 'Appointments', icon: HiOutlineCalendar, path: '/dashboard/appointments' },
    { name: 'Queue', icon: HiOutlineUserGroup, path: '/dashboard/queue' },
    { name: 'Services', icon: HiOutlineClipboardList, path: '/dashboard/services' },
    { name: 'Working Hours', icon: HiOutlineClock, path: '/dashboard/workinghours' },
    { name: 'Revenue', icon: HiOutlineCash, path: '/dashboard/revenue' },
    { name: 'Reviews', icon: HiOutlineStar, path: '/dashboard/reviews' },
    // { name: 'Walk-in Booking', icon: HiOutlineUserGroup, path: '/dashboard/walkinbooking' },
    { name: 'Notifications', icon: HiOutlineBell, path: '/dashboard/notification' },
    { name: 'Profile', icon: HiOutlineUserCircle, path: '/dashboard/profile' },
];

/* Commented out rest of menu items as per request
const extraMenuItems = [
    { name: 'Availability', icon: HiOutlineClock, path: '/dashboard/availability' },
    { name: 'Walk-in Booking', icon: HiOutlineUserGroup, path: '/dashboard/walkinbooking' },
    { name: 'Post', icon: HiOutlineSpeakerphone, path: '/dashboard/post' },
    { name: 'Ads Booking', icon: HiOutlineSpeakerphone, path: '/dashboard/advertisementbooking' },
    { name: 'Referral', icon: HiOutlineShare, path: '/dashboard/referral' },
    { name: 'Wallet', icon: HiOutlineWallet, path: '/dashboard/wallet' },
    { name: 'Support', icon: HiOutlineSupport, path: '/dashboard/support' },
];
*/

const MainLayout = ({ children }) => {
    const [isSidebarOpen, setSidebarOpen] = useState(true);
    const [profileData, setProfileData] = useState(null);
    const [clinicLogo, setClinicLogo] = useState(null);
    const [doctorName, setDoctorName] = useState(Cookies.get('Doctor_name')?.replace(/"/g, '') || Cookies.get('doctor_Name')?.replace(/"/g, '') || 'Doctor');
    const [clinicName, setClinicName] = useState(Cookies.get('Clinic_name')?.replace(/"/g, '') || Cookies.get('clinic_name')?.replace(/"/g, '') || 'Clinic');
    const [doctorAvatar, setDoctorAvatar] = useState(localStorage.getItem('profilePath') || Cookies.get('vendor_profile_path') || null);
    const history = useHistory();
    const location = useLocation();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
            if (window.innerWidth < 768) {
                setSidebarOpen(false);
            }
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        fetchClinicLogo();
        fetchDoctorDetails();
    }, []);

    const fetchDoctorDetails = async () => {
        try {
            const doctorId = Cookies.get('Doctor_id') || Cookies.get('doctor_id');
            if (!doctorId) return;

            const response = await axiosInstance.post('doctor/getDoctorDetails', { doctorId });
            if (response.data?.status === 1 && Array.isArray(response.data.data) && response.data.data[0]) {
                const doc = response.data.data[0];
                if (doc.doctorName) {
                    setDoctorName(doc.doctorName);
                    Cookies.set('Doctor_name', doc.doctorName, { expires: 1 });
                }
                if (doc.vendor_profile_path && doc.vendor_profile_path.trim() !== '') {
                    setDoctorAvatar(doc.vendor_profile_path);
                    localStorage.setItem('profilePath', doc.vendor_profile_path);
                }
            }

            const cName = Cookies.get('Clinic_name') || Cookies.get('clinic_name');
            if (cName) setClinicName(cName.replace(/"/g, ''));
        } catch (err) {
            console.error("Failed to fetch doctor profile details in MainLayout", err);
        }
    };

    const fetchClinicLogo = async () => {
        try {
            let clinicId = Cookies.get('Clinic_id') || Cookies.get('clinic_id') || localStorage.getItem('clinic_id');
            const doctorId = Cookies.get('Doctor_id') || Cookies.get('doctor_id');

            if (!clinicId && doctorId) {
                const clinicsRes = await axiosInstance.post('doctor/getDoctorClinics', { doctorId });
                if (clinicsRes.data.status === 1 && clinicsRes.data.data?.[0]) {
                    clinicId = clinicsRes.data.data[0].clinicId;
                    Cookies.set('Clinic_id', clinicId, { expires: 1 });
                    Cookies.set('clinic_name', clinicsRes.data.data[0].clinicName, { expires: 1 });
                }
            }

            if (!clinicId) return;

            const response = await axiosInstance.post('doctor/getClinicProfile', {
                clinic_id: clinicId
            });

            if (response.data.status === 1 && response.data.data?.[0]) {
                const data = response.data.data[0];
                setProfileData(data);
                const logo = data.profileImage || data.vendor_profile_path;
                if (logo && logo.trim() !== "") {
                    setClinicLogo(logo);
                }
            }
        } catch (e) {
            console.error('Failed to fetch clinic profile data', e);
        }
    };

    const handleLogout = () => {
        logout(history);
    };

    return (
        <div className="min-h-screen bg-gray-50 flex">
            {/* Mobile Overlay */}
            {isMobile && isSidebarOpen && (
                <div 
                    className="fixed inset-0 bg-black/50 z-40 transition-opacity"
                    onClick={() => setSidebarOpen(false)}
                />
            )}

            {/* Sidebar */}
            <aside
                className={`${
                    isMobile 
                        ? (isSidebarOpen ? 'translate-x-0 w-64' : '-translate-x-full w-64') 
                        : (isSidebarOpen ? 'translate-x-0 w-64' : 'translate-x-0 w-20')
                } bg-white border-r border-gray-200 transition-transform duration-300 fixed h-full z-50 flex flex-col overflow-x-hidden shadow-sm md:shadow-none`}
            >
                <div className="h-16 flex-shrink-0 flex items-center justify-between px-3.5 border-b border-gray-100 overflow-hidden">
                    {isSidebarOpen || isMobile ? (
                        clinicLogo ? (
                            <img src={clinicLogo} alt="Logo" className="h-10 w-auto object-contain py-1 max-w-[140px]" style={{ borderRadius: "8px" }} />
                        ) : (
                            <div className="w-9 h-9 bg-teal-600 rounded-lg flex items-center justify-center text-white font-bold text-base shadow-2xs">D</div>
                        )
                    ) : (
                        <div className="w-8 h-8 bg-teal-600 rounded-lg flex items-center justify-center text-white font-bold shadow-2xs mx-auto shrink-0">D</div>
                    )}
                    <button
                        onClick={() => setSidebarOpen(!isSidebarOpen)}
                        className="p-1.5 rounded-lg hover:bg-teal-50 text-gray-500 hover:text-teal-600 transition-colors shrink-0"
                    >
                        {isSidebarOpen ? <HiOutlineX size={18} /> : <HiOutlineMenuAlt2 size={18} />}
                    </button>
                </div>

                <nav className="flex-1 overflow-y-auto overflow-x-hidden p-2.5 space-y-1">
                    {menuItems.map((item) => {
                        const isActive = location.pathname === item.path;
                        return (
                            <button
                                key={item.name}
                                onClick={() => {
                                    history.push(item.path);
                                    if (isMobile) setSidebarOpen(false);
                                }}
                                className={`w-full flex items-center ${isSidebarOpen ? 'gap-2.5 px-3 py-2' : 'justify-center p-2.5'} rounded-lg transition-all relative group overflow-hidden ${isActive
                                    ? 'bg-teal-50 text-teal-700 font-bold'
                                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-800 font-semibold'
                                    }`}
                            >
                                <item.icon size={20} className={`shrink-0 ${isActive ? 'text-teal-600' : ''}`} />
                                {isSidebarOpen && <span className="text-xs truncate">{item.name}</span>}
                                {isActive && isSidebarOpen && <div className="ml-auto w-1.5 h-1.5 bg-teal-600 rounded-full shrink-0" />}
                            </button>
                        );
                    })}
                </nav>

                <div className="flex-shrink-0 p-2.5 border-t border-gray-100 overflow-hidden">
                    <button
                        onClick={handleLogout}
                        className={`w-full flex items-center ${isSidebarOpen ? 'gap-2.5 px-3 py-2' : 'justify-center p-2.5'} text-rose-600 hover:bg-rose-50 rounded-lg transition-all relative group overflow-hidden font-semibold`}
                    >
                        <HiOutlineLogout size={20} className="shrink-0" />
                        {isSidebarOpen && <span className="text-xs truncate">Logout</span>}
                    </button>
                </div>
            </aside>

            {/* Main Content */}
            <main className={`flex-1 transition-all duration-300 min-w-0 ${isMobile ? 'ml-0 pb-16' : (isSidebarOpen ? 'ml-64' : 'ml-20')}`}>
                {/* Header */}
                <header className="h-14 bg-white border-b border-gray-200 flex items-center justify-between px-3 sm:px-6 sticky top-0 z-30">
                    <div className="flex items-center gap-2.5 min-w-0">
                        {isMobile && (
                            <button 
                                onClick={() => setSidebarOpen(!isSidebarOpen)} 
                                className="p-1.5 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors border-none bg-transparent cursor-pointer shrink-0"
                            >
                                <HiOutlineMenuAlt2 size={22} />
                            </button>
                        )}
                        <h1 className="text-sm sm:text-base font-bold text-gray-800 truncate m-0">
                            {menuItems.find(item => item.path === location.pathname)?.name || 'Clinic Management'}
                        </h1>
                    </div>

                    <div
                        className="flex items-center gap-2 cursor-pointer hover:opacity-90 transition-opacity shrink-0"
                        onClick={() => history.push('/dashboard/profile')}
                    >
                        <div className="text-right leading-tight hidden sm:block">
                            <p className="text-sm font-bold text-gray-900 m-0">
                                {doctorName}
                            </p>
                            <p className="text-[12px] text-gray-400 font-medium m-0 mt-0.5">
                                {clinicName}
                            </p>
                        </div>
                        {doctorAvatar ? (
                            <img
                                src={doctorAvatar}
                                alt="Doctor Profile"
                                className="w-8 h-8 sm:w-9 sm:h-9 rounded-full object-cover border border-teal-500 shadow-2xs shrink-0"
                            />
                        ) : (
                            <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-teal-100 border border-teal-500 shadow-2xs flex items-center justify-center text-teal-700 font-bold text-xs shrink-0">
                                {doctorName.charAt(0) || 'D'}
                            </div>
                        )}
                    </div>
                </header>

                {/* Content Area */}
                <div className="p-2.5 sm:p-4 w-full box-border overflow-x-hidden">
                    {children}
                </div>
            </main>

            {/* Mobile Bottom Navigation Bar */}
            {isMobile && (
                <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-40 flex items-center justify-around py-1.5 px-1 shadow-lg">
                    {[
                        { name: 'Home', icon: HiOutlineHome, path: '/dashboard' },
                        { name: 'Appointments', icon: HiOutlineCalendar, path: '/dashboard/appointments' },
                        { name: 'Queue', icon: HiOutlineUserGroup, path: '/dashboard/queue' },
                        { name: 'Services', icon: HiOutlineClipboardList, path: '/dashboard/services' },
                        { name: 'Revenue', icon: HiOutlineCash, path: '/dashboard/revenue' },
                    ].map((item) => {
                        const isActive = location.pathname === item.path;
                        return (
                            <button
                                key={item.name}
                                onClick={() => history.push(item.path)}
                                className={`flex flex-col items-center justify-center py-1 px-1.5 rounded-lg transition-colors border-none bg-transparent cursor-pointer ${
                                    isActive ? 'text-teal-600 font-bold' : 'text-gray-500 hover:text-gray-700'
                                }`}
                            >
                                <item.icon size={20} className={isActive ? 'text-teal-600' : 'text-gray-500'} />
                                <span className="text-[10px] mt-0.5 leading-tight">{item.name}</span>
                            </button>
                        );
                    })}
                </nav>
            )}
        </div>
    );
};

export default MainLayout;

